import { render } from "./LiftParams.vue?vue&type=template&id=e893bb66"
import script from "./LiftParams.vue?vue&type=script&lang=js"
export * from "./LiftParams.vue?vue&type=script&lang=js"

import "./LiftParams.vue?vue&type=style&index=0&id=e893bb66&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__